const $$splitComponentImporter = () => import('/app/frontend/src/routes/_app/fleet-management/contracts/$contractId.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_app/fleet-management/contracts/$contractId')({
  staticData: {
    breadCrumb: 'Contract Detail'
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});

/**
 * Contract data / Commercial tabs (view mode — Commercial absent without
 * Accounting read, per Appendix A). Contract amendments and Payment plan are
 * separate tracks (NEWF-41/NEWF-42) and aren't built, so they carry no tab
 * yet — adding an always-empty one would be worse than omitting it. The edit
 * cycle is category-scoped: Contract Data fields need `access.data ===
 * 'write'`, Commercial fields need `access.accounting === 'write'` — a caller
 * with only one of the two still gets an edit cycle, with the other
 * category's fields shown read-only.
 */

/**
 * The five purchase condition cards (purchase_contract_v0.1.md, Section 3):
 * Ownership and financing, Order and delivery, Price and terms (+ Original
 * condition on a used vehicle), Warranty, Statutory warranty — in that
 * order, following the Vehicles card on the Contract data tab.
 */